import { Preferences } from '@capacitor/preferences';
import { Capacitor } from '@capacitor/core';

export async function setOfflineCache(key: string, data: any) {
  try {
    let sanitizedData = data;
    // Cap order cache to 30 items to stay safely below the 5MB browser quota
    if (sanitizedData && typeof sanitizedData === 'object' && Array.isArray(sanitizedData.orders) && sanitizedData.orders.length > 30) {
      sanitizedData = {
        ...sanitizedData,
        orders: sanitizedData.orders.slice(0, 30),
      };
    }

    const val = JSON.stringify(sanitizedData);
    if (Capacitor.isNativePlatform()) {
      await Preferences.set({ key, value: val });
    } else {
      try {
        localStorage.setItem(key, val);
      } catch (quotaErr) {
        // Handle QuotaExceededError by evicting secondary caches
        console.warn(`[offlineCache] Quota exceeded on key "${key}". Evicting secondary caches.`);
        try {
          localStorage.removeItem('pd_cached_orders_archived');
          localStorage.removeItem('pd_memory_queue');
          localStorage.setItem(key, val);
        } catch {
          console.error(`[offlineCache] Hard quota limit reached; unable to cache key "${key}".`);
        }
      }
    }
  } catch (err) {
    console.warn(`setOfflineCache failed for key ${key}:`, err);
  }
}

export async function getOfflineCache(key: string): Promise<any | null> {
  try {
    let val: string | null = null;
    if (Capacitor.isNativePlatform()) {
      const { value } = await Preferences.get({ key });
      val = value;
    } else {
      val = localStorage.getItem(key);
    }
    return val ? JSON.parse(val) : null;
  } catch (err) {
    console.warn(`getOfflineCache failed for key ${key}:`, err);
    return null;
  }
}

export async function removeOfflineCache(key: string) {
  try {
    if (Capacitor.isNativePlatform()) {
      await Preferences.remove({ key });
    } else {
      localStorage.removeItem(key);
    }
  } catch (err) {
    console.warn(`removeOfflineCache failed for key ${key}:`, err);
  }
}
